import { EngineTheme } from '@websky/core/src/theme';
import * as SearchForm from './siteSearchFormTheme.css';

// theme applied to the search form on the client's site
export default {
	SearchForm: {
		Passengers: {
			selector: SearchForm.passengersTrigger
		},
		Segment: {
			segment: SearchForm.segment
		},
		SearchForm: {
			beforeAdornment__wrapper: SearchForm.beforeAdornment__wrapper,
			row: SearchForm.row,
			searchForm: SearchForm.searchForm
		},
		Location: {
			input: SearchForm.locationInput
		},
		Bottom: {
			bottom: SearchForm.bottom
		}
	}
} as EngineTheme;
